import PropTypes from 'prop-types';
import React from 'react';
import {AnyToDo} from '../../../typings/todo';
import {ShareButtons} from '../../components/ShareButtons/ShareButtons';
import {getSiteInfo} from '../../services/env/siteInfo/siteInfo';
import {withSiteSettings} from '../DataContainer/siteSettings/withSiteSettings';
import {canShareEntitySelector} from './selectors';

class ShareButtonsContainerComponent extends React.Component<AnyToDo, AnyToDo> {
  static propTypes = {
    className: PropTypes.string,
    album: PropTypes.any,
    track: PropTypes.any,
    isDisabled: PropTypes.bool,
    withText: PropTypes.bool,
    siteSettings: PropTypes.object,
  };
  state = {
    siteInfo: null,
  };

  componentDidMount() {
    getSiteInfo().then((siteInfo) => this.setState({siteInfo}));
  }

  render() {
    const {album, track, siteSettings} = this.props;
    const {siteInfo} = this.state;
    if (!siteInfo) {
      return null;
    }

    return canShareEntitySelector({album, track, siteSettings}) ? (
      <ShareButtons siteInfo={siteInfo} {...this.props} />
    ) : null;
  }
}

export const ShareButtonsContainer = withSiteSettings(ShareButtonsContainerComponent);
